export const timeout = (delay) => {
    return new Promise(res => setTimeout(res, delay));
}

export function randomIntFromInterval(min, max)
{
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export function shuffleArray(array) {
    const arrayCopy = [...array];
    let currentIndex = arrayCopy.length;

    while(currentIndex !== 0) {
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        [arrayCopy[currentIndex], arrayCopy[randomIndex]] = [arrayCopy[randomIndex], arrayCopy[currentIndex]];
    }

    return arrayCopy;
}

export function checkContainedArray(array, subArray, notEqual = false) {
    if(array.length < subArray.length || (notEqual && array.length === subArray.length)) return false;

    return subArray.every(e => array.includes(e));
}

export function checkContainedString(str, subStr, notEqual = false, caseSensitive = false) {
    if(str.length < subStr.length || (notEqual && str.length === subStr.length)) return false;

    return caseSensitive ? str.toLowerCase().includes(subStr.toLowerCase()) : str.includes(subStr);
}